<div role="separator" id="start_sep" aria-labelledby="start_sep" aria-label="Start of carousel"></div>
<section
	*ngIf="(heroItems$ | async)?.length"
	class="hero-carousel-panel"
	aria-roledescription="carousel"
	aria-label="Home page hero"
>
	<div class="item-controls">
		<div class="item-pagination" aria-hidden="true">
			<div class="current-page">{{ +(currentIndex ?? 0) + 1 }} / {{ heroItemsCount }}</div>
		</div>
		<div class="item-control-icons">
			<button
				id="stop-auto-rotation"
				*ngIf="rotationStatus !== 'stopped'"
				class="item-control-icon"
				(click)="stopAutoRotation()"
				aria-label="Stop automatic slide show"
				(focus)="stopAutoRotation()"
			>
				<cdx-svg-icon name="pause" size="extra-small" start></cdx-svg-icon>
			</button>
			<button
				id="start-auto-rotation"
				*ngIf="rotationStatus === 'stopped'"
				class="item-control-icon"
				(click)="startAutoRotation()"
				aria-label="Start automatic slide show"
			>
				<cdx-svg-icon name="play" size="extra-small" start></cdx-svg-icon>
			</button>
			<button id="to-left-item" class="item-control-icon" (click)="previousClick()" aria-label="Previous slide">
				<cdx-svg-icon name="chevron-left" fill="currentColor" size="extra-small" start></cdx-svg-icon>
			</button>
			<button id="to-right-item" class="item-control-icon" (click)="nextClick()" aria-label="Next slide">
				<cdx-svg-icon name="chevron-right" fill="currentColor" size="extra-small" start></cdx-svg-icon>
			</button>
		</div>
	</div>
	<div class="hero-carousel-container" [attr.aria-live]="liveStatusMapping[rotationStatus]">
		<div class="hero-items" #heroCarousel [ngStyle]="carouselStyle">
			<wnz-hero-item
				*ngIf="!!heroItems[heroItemsCount - 1]"
				aria-hidden="true"
				[item]="heroItems[heroItemsCount - 1]"
				[currentIndex]="-1"
				[totalItemsCount]="heroItemsCount"
				[tabindex]="-1"
				[isLazyLoading]="true"
			>
			</wnz-hero-item>
			<wnz-hero-item
				*ngFor="let item of heroItems$ | async; let i = index; let l = count; trackBy: trackByHeroItemId"
				[attr.aria-hidden]="(currentIndex$ | async) !== i"
				cdxSwipe="horizontal"
				[item]="item"
				[currentIndex]="i"
				[totalItemsCount]="heroItemsCount"
				[tabindex]="(currentIndex$ | async) === i ? 0 : -1"
				[isLazyLoading]="(currentIndex$ | async) !== i"
				[cdxTrackImpression]="promoBannerImpressionArgs[i]"
				[ngClass]="getAdditionalClassNames(i, item)"
				(focusin)="stopAutoRotation()"
				(mouseenter)="pauseAutoRotation()"
				(mouseleave)="resumeAutoRotation()"
				(swipeLeft)="onSwipeLeft()"
				(swipeRight)="onSwipeRight()"
				(swipeMove)="onSwipeMove($event)"
				(onTcLinkClick)="onTcLinkClick()"
			>
			</wnz-hero-item>
			<wnz-hero-item
				*ngIf="!!heroItems[0]"
				aria-hidden="true"
				[item]="heroItems[0]"
				[currentIndex]="-1"
				[totalItemsCount]="heroItemsCount"
				[tabindex]="-1"
				[isLazyLoading]="true"
			>
			</wnz-hero-item>
		</div>
	</div>
</section>
<div role="separator" id="end_sep" aria-labelledby="end_sep" aria-label="End of carousel"></div>
